<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :visibleCreate="true" :loading="loading" @stored="stored" :visibleStore="updatePermission"
        :filter="true" filterLabel="検索">
          <template v-slot:status="{ item }">
              <v-chip v-show="item.status === statuses.notReceived.value" color="error" text-color="white">
                  <v-avatar left><v-icon>mdi-pencil-circle</v-icon></v-avatar>{{ statuses.notReceived.name }}
              </v-chip>
              <v-chip v-show="item.status === statuses.received.value" color="warning" text-color="white">
                  <v-avatar left><v-icon>mdi-circle-slice-8</v-icon></v-avatar>{{ statuses.received.name }}
              </v-chip>
              <v-chip v-show="item.status === statuses.missing.value" color="grey" text-color="white">
                  <v-avatar left><v-icon>mdi-close-circle</v-icon></v-avatar>{{ statuses.missing.name }}
              </v-chip>
              <v-chip v-show="item.status === statuses.reflect.value" color="success" text-color="white">
                  <v-avatar left><v-icon>mdi-check-circle</v-icon></v-avatar>{{ statuses.reflect.name }}
              </v-chip>
          </template>
          <template v-slot:action="{ item }">
            <v-btn class="mr-2" depressed small color="warning" :to="{ name: 'ConstructionMasterDetail', params: { id: item.id } }">詳細</v-btn>
            <v-btn v-show="deletePermission && (item.status === statuses.notReceived.value)" class="mr-2" depressed small @click.stop="deleted(item)" color="error">削除</v-btn>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <!-- 削除ボタン押下後に表示されるダイアログ -->
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
        @deleted="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import ConstructionApi from "@/api/construction-api"
  import ConstructionDepartmentApi from "@/api/construction-department-api"
  import CustomDataTable from "@/components/custom_ui/CustomDataTable"
  import CustomDialog from "@/components/custom_ui/CustomDialog"

  export default {
    name: "ConstructionMaster",
    components: {
      CustomDataTable,
      CustomDialog
    },
    props: ["user"],
    data: () => ({
      // 共通コンポーネント: データテーブル関連
      loading: false,
      tableName: '工事情報',
      headers: [
        { text: "ステータス", value: "status" },
        { text: "工番", value: "construction_number" },
        { text: "工事名", value: "construction_name" },
        { text: "工期(自)", value: "start_date" },
        { text: "工期(至)", value: "end_date" },
        { text: "監督者", value: "management_user_name" },
        { text: "アクション", value: "action" }
      ],
      items: [],
      statuses: {
        notReceived: { name: "未受注", value: 0 },
        received: { name: "受注済", value: 1 },
        missing: { name: "失注済", value: 2 },
        reflect: { name: "実績反映済", value: 3 }
      },

      // 削除ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,
      deleteId: null,

      // 権限
      updatePermission: true,
      deletePermission: true,
      displayPermission: false
    }),
    created () {
      this.initialize ()
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        if (this.user.role_id == 0) {
          this.updatePermission = this.user.permission_config.CTSG00010.update;
          this.deletePermission = this.user.permission_config.CTSG00010.delete;
          this.displayPermission = this.user.permission_config.CTSG00010.display;
        }
        this.constructionApi = new ConstructionApi();
        this.constructionDepartmentApi = new ConstructionDepartmentApi();
        const promise = this.constructionDepartmentApi.list("0");
        promise.then((response) => {
          for (var item of response.data.body.construction_department_list) {
            this.items.push(item);
          }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError){
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "Dashboard" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
            this.isLoading();
        });
      },

      // 新規作成ボタン押下時のイベント
      stored () {
        this.$router.push({ name: 'CreateConstructionMaster' })
      },
      // 削除ボタン押下時イベント
      deleted (item) {
        this.deleteId = item.id
        this.dialogTitle = '削除しますか？'
        this.dialogItems = [
          { name: '工番', value: item.construction_number },
          { name: '工事名', value: item.construction_name },
          { name: '工事場所', value: item.place },
          { name: '工期(自)', value: item.start_date },
          { name: '工期(至)', value: item.end_date},
          { name: "発注者", value: item.order_name },
          { name: "施工者", value: item.builder_name },
          { name: "監督者", value: item.management_user_name },
          { name: "歩掛", value: item.percentage_flg },
        ]
        this.dialogDrawer = true
      },
      dialogCancel () {
        this.dialogDrawer = false
      },
      // ダイアログ削除ボタン押下時イベント
      submit() {
        this.isLoading();
        const promise = this.constructionApi.delete(this.deleteId)
        promise.then((response) => {
            this.items = this.items.filter((item) => {
              return (item.id !== this.deleteId);
            });
            this.deleteId = null
            this.dialogDrawer = false
            this.$emit('success', response.data.message)
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    },
  }
</script>
